import { useMemo } from "react";
import {
  CONTENT_SECTOR_TYPE,
  ContentSectorDataType,
  WebStoreSelectorType,
} from "../../controller/MasterController";
import { ThemeType } from "../../recoil/theme";
import { contentName, getSectorParentName } from "../../utils/util";
import StoreContent from "./content/storeContent";

interface SectorCategoryProps {
  storeList: WebStoreSelectorType | undefined;
  lang: number;
  currentDate: Date;
  selectedCategory: ContentSectorDataType | null;
  navigateSector: any;
  navigateStore: any;
  theme: ThemeType;
}

const SectorCategory = ({
  storeList,
  lang,
  currentDate,
  selectedCategory,
  navigateSector,
  navigateStore,
  theme,
}: SectorCategoryProps) => {
  const SectorCategory = useMemo(() => {
    return (
      <>
        {storeList?.main_section?.map?.((main, index) => {
          return (
            <div key={index} className="centerWrap">
              <div className="deliveryTitle">
                <div className="row">
                  <h2>{contentName("카테고리", lang)}</h2>
                  {theme.category && <img src={theme.category} alt="box" />}
                </div>
              </div>
              <div className="normalStoreWrap sector">
                {main?.content?.map(
                  (group, index) =>
                    group.content_type === CONTENT_SECTOR_TYPE && (
                      <div
                        key={index}
                        className={`sectorItem ${
                          selectedCategory &&
                          group.data.parent_store_sector_id ===
                            selectedCategory.parent_store_sector_id &&
                          "active"
                        }`}
                        onClick={() => navigateSector(group)}
                      >
                        <img
                          src={
                            group.data.sector_url
                              ? group.data.sector_url
                              : `${process.env.PUBLIC_URL}/knockknock/img/logo.png`
                          }
                          alt="icon"
                        />
                        <h3>{getSectorParentName(group.data, lang)}</h3>
                      </div>
                    )
                )}
              </div>
              {selectedCategory && (
                <>
                  <div className="line" />
                  <div className="deliveryTitle">
                    <div className="row">
                      <h2>{getSectorParentName(selectedCategory, lang)}</h2>
                      <img
                        src={
                          selectedCategory.sector_url
                            ? selectedCategory.sector_url
                            : `${process.env.PUBLIC_URL}/knockknock/img/logo.png`
                        }
                        alt="siren"
                      />
                    </div>
                  </div>
                  <div className="normalStoreWrap">
                    {selectedCategory.store_list.map((item, index) => (
                      <StoreContent
                        key={index}
                        item={{
                          content_type: "STORE",
                          data: item,
                        }}
                        currentDate={currentDate}
                        navigateSector={() =>
                          navigateStore(selectedCategory.store_list, index)
                        }
                        type={"main"}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          );
        }) ?? null}
      </>
    );
  }, [storeList, lang, selectedCategory, currentDate]);

  return SectorCategory;
};
export default SectorCategory;
